import api from '../api';

let apiUrl = 'product-groups';
import _ from 'lodash';

const state = {
    data: {},
    meta: {}
};

const actions = {
    show: async ({ commit }, id) => {
        return await api
            .get(`/api/v1/${apiUrl}/${id}`)
            .then((response) => {
                commit('set', response.data);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    }
};

const mutations = {
    set(state, data) {
        state.data = data.data;
        state.meta = data.meta;
    }
};

const getters = {
    get(state, data) {
        return state.data;
    },
    getProducts(state, data) {
        return state.data.products.data.filter((product) => product.optional === false);
    },
    getProduct(state, data) {
        return state.data.products.data.find((product) => product.optional === false);
    },
    getWebinars(state, data) {
        return state.data.products.data.filter((product) => product.optional === true);
    },
    getWebinar(state, data) {
        return state.data.products.data.find((product) => product.optional === true);
    },
    getWebinarVariantByPeriod: (state) => (period) => {
        let selectedProductVariant = null;

        state.data.products.data.forEach((product) => {
            if (product.optional === true) {
                // ensure it is a webinar
                product.productVariants.data.forEach((productVariant) => {
                    let periodEqual = false;

                    productVariant.productAttributeValues.data.forEach((productAttributeValue) => {
                        if (productAttributeValue.meta.type === 'period' && productAttributeValue.meta.runtime_in_days === period) {
                            periodEqual = true;
                        }
                    });

                    if (periodEqual) {
                        selectedProductVariant = productVariant;
                        return;
                    }
                });
            }
            return;
        });

        return selectedProductVariant;
    },
    getProductAttributesByType: (state) => (type) => {
        let attributeTypes = [];

        state.data.products.data.forEach((product) => {
            if (product.optional === false) {
                // only for Products
                product.productVariants.data.forEach((productVariant) => {
                    productVariant.productAttributeValues.data.find((productAttributeValue) => {
                        if (productAttributeValue.meta.type === type) {
                            if (!_.some(attributeTypes, productAttributeValue)) {
                                attributeTypes.push(productAttributeValue);
                            }
                        }
                    });
                });
            }
        });

        return attributeTypes;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
